import { clearProfileInfo, setProfileInfo } from './profileSlice';

export const removeProfileInfo = () => clearProfileInfo();

export const updateProfileInfo = (data) => {
  if (!data) return null;
  return async (dispatch) => {
    dispatch(upsertProfileInfo(data));
  };
};

export const forceProfileInfo = () => {
  return async (dispatch) => {
    dispatch(
      setProfileInfo({
        id: '37837871299217987892',
        name: 'Admin Avigrupo',
        email: 'admin@avigrupo.com',
        phone: '+54040949490',
        company: 'avigrupo',
        avatar: undefined,
        role: 'admin',
        scopes: ['*'],
        status: true,
        metadata: {},
        background: '#666',
      })
    );
  };
};
